module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-2.39de1a27.jpg";